<template>
  <div class="w-full flex justify-center bg-[#f9f8f6] font-rubik quote-builder-sub-header-container px-3 1170-bp:px-0">
    <div class="w-full max-w-[1216px] flex flex-col quote-builder-sub-header-inner-container">
      <picture class="quote-builder-subheader-picture">
        <source
          media="(max-width: 1024px)"
          srcset="@/images/quote-builder/quote-builder-banner-mobile.png"
        />
        <img
          class="quote-builder-subheader-img"
          src="@/images/quote-builder/quote-builder-banner.png"
          alt="Banner image"
        />
      </picture>
      <div class="flex justify-between items-center px-5 quote-builder-sub-header-bottom-half">
        <div class="sub-header-text-container">
          <h1>Quote Builder</h1>
          <p>Fill in your info below.</p>
        </div>
        <button @click="home()" class="flex justify-center items-center transition-all">
          <img src="@/images/quote-builder/home.svg" alt="Return to home page">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    home() {
      window.location.href = '/'
    }
  }
}
</script>

<style scoped>
.quote-builder-sub-header-container {
  padding-top: 48px;
}

.quote-builder-sub-header-inner-container {
  border: 2px solid #EDE9E3;
  border-radius: 12px;
}

.quote-builder-subheader-picture {
  width: 100%;
  max-height: 240px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

.quote-builder-subheader-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.quote-builder-sub-header-bottom-half {
  width: 100%;
  height: 112px;
  background-color: #FFF;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.quote-builder-sub-header-bottom-half h1 {
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: -0.02em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #334155;
}

.quote-builder-sub-header-bottom-half p {
  padding-bottom: 3px;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.02em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #334155;
}

.quote-builder-sub-header-bottom-half button {
  width: 44px;
  height: 44px;
  background-color: #eee9e3;
  border: 1px solid #EDE9E3;
  border-radius: 10px;
}

.quote-builder-sub-header-bottom-half button:hover {
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
              0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.sub-header-text-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 2rem;
}

/* Mobile Styles */
@media (max-width: 1024px) {
  .quote-builder-sub-header-bottom-half h1 {
    font-size: 32px;
    font-weight: 400;
    line-height: 38.4px;
    letter-spacing: -0.04em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  
  .quote-builder-subheader-picture {
    height: 160px;
  }
  
  .quote-builder-subheader-img {
    height: 100%;
    object-fit: cover;
  }
  
  .sub-header-text-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 0rem;
  }
}
</style>
